<template>
  <div id="error-Page" :class="[errorPage?'hasBg':'']">
    <div class="errorTextBox" v-if="!errorPage">
      {{errorMsg}}
    </div>
    <div class="errorCover" v-if="errorPage">
      <div class="logo">
        <img :src="logo" alt="">
      </div>
      <div class="mainText">
        <div class="title" v-html="errorPage.title"></div>
        <div class="titleDes pc" v-for="(item,index) in errorPage.titleDesPc" :key="index" v-html="item">【小数答题】是一个调研任务有偿参与平台</div>
        <div class="titleDesBox phone" v-html="errorPage.titleDesmoblie"></div>
      </div>
      <div class="mainBottom">
        <div class="stepBox">
          <div class="stepBoxInner">
            <div class="stepTop">
              <div class="step1Ico">
                <div class="stepRound">1</div>
                <div class="stepliner"></div>
              </div>
              <div class="step2Ico">
                <div class="stepRound">2</div>
                <div class="steplinel"></div>
                <div class="stepliner"></div>
              </div>
              <div class="step3Ico">
                <div class="stepRound">3</div>
                <div class="steplinel"></div>
              </div>
            </div>
            <div class="stepBottom">
              <div class="stepBitem" v-for="(item,index) in errorPage.stepBitem" :key="index">
                <p class="stepBitemT" v-html="item.stepBitemT"></p>
                <div :class="['stepIco',item.stepIcoClass]"></div>
                <div class="stepBitemD" v-html="item.stepBitemD"></div>
                <div class="stepBitemD" v-html="item.stepBitemD2"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="codeBox">
          <div class="ewmBox">
            <img :src="codeIco" alt="">
          </div>
          <div class="codeText" v-html="errorPage.ewm.codeText"></div>
          <div class="codeText" v-html="errorPage.ewm.codeText2"></div>
          <!-- <p></p> -->
        </div>
      </div>
    </div>
    <!-- <div class="errorCover" v-if="errorPage">
      <div class="logo">
        <img src="../../assets/images/errorPage/logo1.jpg" alt="">
      </div>
      <div class="mainText">
        <div class="title"><span class="mrSpace">让您的观点</span><span>改变未来</span></div>
        <div class="titleDes pc">【点调查】是一个调研任务有偿参与平台</div>
        <div class="titleDes pc">您可以通过微信公众号参与调研任务并获得现金回报</div>
        <div class="titleDes pc">目前已累计发布<span class="cy">20000+</span>个调研任务， 发放<span class="cy">2500万</span>现金奖励</div>
        <div class="titleDesBox phone">
          【点调查】是一个调研任务有偿参与平台，您可以通过微信公众号参与调研任务并获得现金回报，目前已累计发布<span class="cy">20000+</span>个调研任务， 发放<span class="cy">2500万</span>现金奖励
        </div>
      </div>
      <div class="mainBottom">
        <div class="stepBox">
          <div class="stepBoxInner">
            <div class="stepTop">
              <div class="step1Ico">
                <div class="stepRound">1</div>
                <div class="stepliner"></div>
              </div>
              <div class="step2Ico">
                <div class="stepRound">2</div>
                <div class="steplinel"></div>
                <div class="stepliner"></div>
              </div>
              <div class="step3Ico">
                <div class="stepRound">3</div>
                <div class="steplinel"></div>
              </div>
            </div>
            <div class="stepBottom">
              <div class="stepBitem">
                <p class="stepBitemT">注册</p>
                <div class="stepRes"></div>
                <div class="stepBitemD">600万+用户</div>
                <div class="stepBitemD">微信公众号快速登录</div>
              </div>
              <div class="stepBitem">
                <p class="stepBitemT">答卷</p>
                <div class="stepWri"></div>
                <div class="stepBitemD">2000+任务发布</div>
                <div class="stepBitemD">每天都有新任务</div>
              </div>
              <div class="stepBitem">
                <p class="stepBitemT">兑奖</p>
                <div class="stepGig"></div>
                <div class="stepBitemD">2500w奖励发放</div>
                <div class="stepBitemD">直接到账微信钱包</div>
              </div>
            </div>
          </div>
        </div>
        <div class="codeBox">
          <div class="ewmBox">
            <img src="../../assets/images/errorPage/code.png" alt="">
          </div>
          <div class="codeText">关注公众号</div>
          <div class="codeText">答卷更方便</div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import ComConfig from '../../utils/comConfig'
export default {
  data() {
    return {
      errorMsg: this.$route.query.errorMsg ? this.$route.query.errorMsg : '',
      errorPage:null,
      logo:'',
      codeIco:''
    }
  },
  created() {
    let env = process.env.VUE_APP_Version
    ComConfig.forEach(item=>{
      if(item.env === env){
        this.errorPage = item.errorPage
        this.logo = require(`../../assets/images/errorPage/${item.errorPage.titlelogo}`)
        this.codeIco = require(`../../assets/images/errorPage/${item.errorPage.ewm.ico}`)
      }
    })
  }
}
</script>
<style lang='less'>
#error-Page {
  position: relative;
  padding-top: 20px;
  font-size: 16px;
  height: 100%;
  &.hasBg{
     padding-top: 0px;
     background: #fff url(../../assets/images/errorPage/bg1.jpg) no-repeat center center;
    background-size: cover;
  }
  .errorCover{
    position: relative;
    padding: 10px 20px 0 10px;
    .logo{
      img{
        display: block;
        width: 31px;
        height: 39px;
        border-radius: 2px;
        -webkit-box-reflect: below 0px -webkit-linear-gradient(transparent 80%,rgba(0,0,0,.3));
        box-reflect: below 0px linear-gradient(transparent 80%,rgba(0,0,0,.3));
      }
    }
    .mainText{
      position: absolute;
      top: 30px;
      right: 20px;
      color: #fff;
      font-size: 5px;
      .title{
        font-size: 8px;
        font-weight: bold;
        text-align: left;
        margin-bottom: 5px;
        // span:first-child{
        //   margin-right: 5px;
        // }
        .mrSpace{
          margin-right: 0.5em;
        }
      }
      .titleDesBox{
        display: none;
        padding: 0 10px;
        text-align: left;
        margin-bottom: 3px;
        .cy{
          color: #FFC000;
        }
      }
      .titleDes{
        text-align: left;
        margin-bottom: 3px;
        .cy{
          color: #FFC000;
        }
        &.pc{
          display: block;
        }
        &.phone{
          display: none;
        }
      }
    }
    .mainBottom{
      position: absolute;
      left: 10px;
      bottom: 10px;
      height: 80px;
      width: calc(100vw - 30px);
    }
    .codeBox{
      position: absolute;
      right: 30px;
      top: 0;
      width: 50px;
      height: 72px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 3px;
      box-sizing: border-box;
      padding: 5px;
      .ewmBox{
        width: 40px;
        height: 40px;
        margin-bottom: 5px;
        img{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .codeText{
        font-size: 6px;
        line-height: 8px;
        margin-bottom: 0px;
        color: #fff;
        padding-top: 0;
        font-weight: bold;
        text-align: center;
      }
    }
    .stepBox{
      position: absolute;
      left: 0px;
      bottom: 0px;
      width: 180px;
      height: 80px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 3px;
      padding: 5px;
      box-sizing: border-box;
      .stepBoxInner{
        height: 100%;
        width: 100%;
        background: #fff;
        box-shadow: 0 0px 2px 2px rgba(255, 255, 255, 1);
        .stepTop{
          height: 15px;
          display: flex;
          // background: royalblue;
          .step1Ico{
            flex: 1;
            height: 10px;
            position: relative;
            .stepRound{
              position: absolute;
              height: 10px;
              width: 10px;
              left: 50%;
              top: 50%;
              z-index: 3;
              background: #999;
              transform: translate(-50%,-50%);
              color: #fff;
              border-radius: 10px;
              font-size: 6px;
              line-height: 10px;
              text-align: center;
            }
          }
          .step2Ico{
            flex: 1;
            height: 10px;
            position: relative;
            .stepRound{
              position: absolute;
              height: 10px;
              width: 10px;
              left: 50%;
              top: 50%;
              z-index: 3;
              background: #999;
              transform: translate(-50%,-50%);
              color: #fff;
              border-radius: 10px;
              font-size: 6px;
              line-height: 10px;
              text-align: center;
            }
          }
          .step3Ico{
            flex: 1;
            height: 10px;
            position: relative;
            .stepRound{
              position: absolute;
              height: 10px;
              width: 10px;
              left: 50%;
              top: 50%;
              z-index: 3;
              background: #999;
              transform: translate(-50%,-50%);
              color: #fff;
              border-radius: 10px;
              font-size: 6px;
              line-height: 10px;
              text-align: center;
            }
          }
          .stepliner{
            position: absolute;
            top: 50%;
            left: 50%;
            right: 0;
            transform: translateY(-50%);
            height: 0.5px;
            background: #999;
            width: 50%;
          }
          .steplinel{
            position: absolute;
            top: 50%;
            left: 0;
            right: 50%;
            transform: translateY(-50%);
            height: 0.5px;
            background: #999;
            width: 50%;
          }
          .stepArrow{
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            // font-weight: bold;
            right: -2px;
            font-size: 8px;
            color: #999;
          }
        }
        .stepBottom{
          height: 54px;
          // background: chocolate;
          display: flex;
          justify-content: space-between;
          .stepBitem{
            box-sizing: border-box;
            width: 55px;
            padding-top: 4px;
            // background: red;
            border: 0.1px solid #dddddd;
            height: 100%;
            .stepBitemT{
              color: #444;
              font-size: 4px;
              text-align: center;
              font-weight: bold;
              margin-bottom: 6px;
            }
            .stepRes{
              width: 15px;
              height: 15px;
              background: url(../../assets/images/errorPage/person.png) no-repeat center center;
              background-size: 100% 100%;
              margin: 0 auto 6px;
            }
            .stepWri{
              width: 17px;
              height: 15px;
              background: url(../../assets/images/errorPage/write.png) no-repeat center center;
              background-size: 100% 100%;
              margin: 0 auto 6px;
            }
            .stepGig{
              width: 16px;
              height: 15px;
              background: url(../../assets/images/errorPage/gift.png) no-repeat center center;
              background-size: 100% 100%;
              margin: 0 auto 6px;
            }
            .stepBitemD{
              font-size: 3px;
              line-height: 1;
              margin-bottom: 1px;
              color: #666;
              text-align: center;
            }
            .stepBitemD:last-child{
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
  
}
.errorCover{
  overflow: auto;
  height: 100%;
  box-sizing: border-box;
  background: rgba(0, 0, 0, .7);
}
@media only screen and (max-width: 800px) {
  #error-Page {
  position: relative;
  padding-top: 20px;
  font-size: 24px;
  height: 100%;
  &.hasBg{
     padding-top: 0px;
     background: #fff url(../../assets/images/errorPage/bg1.jpg) no-repeat center center;
    background-size: cover;
  }
  .errorCover{
    position: relative;
    padding: 20px 0px 0 0px;
    .logo{
      img{
        display: block;
        width: 46.5px;
        height: 58.5px;
        margin: 0 auto;
        border-radius: 5px;
        -webkit-box-reflect: below 0px -webkit-linear-gradient(transparent 80%,rgba(0,0,0,.3));
        box-reflect: below 0px linear-gradient(transparent 80%,rgba(0,0,0,.3));
      }
    }
    .mainText{
      position: relative;
      top: auto;
      right: auto;
      color: #fff;
      font-size: 14px;
      padding-top: 10px;
      padding-bottom: 15px;
      .title{
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 5px;
        .mrSpace{
          margin-right: 0.5em;
        }
      }
      .titleDesBox{
        display: block;
        padding: 0 10px;
        text-align: left;
        font-size: 14px;
        line-height: 24px;
        text-align: left;
        text-indent: 2em;
        margin-bottom: 0px;
        .cy{
          color: #FFC000;
        }
      }
      .titleDes{
        text-align: center;
        margin-bottom: 3px;
        .cy{
          color: #FFC000;
        }
        &.pc{
          display: none;
        }
        &.phone{
          display: block;
        }
      }
    }
    .mainBottom{
      position: relative;
      left: 10px;
      right: 0;
      bottom: auto;
      height: auto;
      width: calc(100vw - 20px);
    }
    .codeBox{
      position: relative;
      right: auto;
      top: auto;
      width: 120px;
      height: auto;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 5px;
      box-sizing: border-box;
      padding: 10px;
      margin: 15px auto;
      .ewmBox{
        width: 100px;
        height: 100px;
        margin-bottom: 10px;
        img{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .codeText{
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 0px;
        color: #fff;
        padding-top: 0;
        font-weight: bold;
        text-align: center;
      }
    }
    .stepBox{
      position: relative;
      left: auto;
      bottom: auto;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 5px;
      padding: 10px;
      box-sizing: border-box;
      .stepBoxInner{
        height: 100%;
        width: 100%;
        background: #fff;
        box-shadow: 0 0px 2px 2px rgba(255, 255, 255, 1);
        .stepTop{
          height: 35px;
          display: flex;
          // background: royalblue;
          .step1Ico{
            flex: 1;
            height: 30px;
            position: relative;
            .stepRound{
              position: absolute;
              height: 20px;
              width: 20px;
              left: 50%;
              top: 50%;
              z-index: 3;
              background: #999;
              transform: translate(-50%,-50%);
              color: #fff;
              border-radius: 20px;
              font-size: 14px;
              line-height: 20px;
              text-align: center;
            }
          }
          .step2Ico{
            flex: 1;
            height: 30px;
            position: relative;
            .stepRound{
             position: absolute;
              height: 20px;
              width: 20px;
              left: 50%;
              top: 50%;
              z-index: 3;
              background: #999;
              transform: translate(-50%,-50%);
              color: #fff;
              border-radius: 20px;
              font-size: 14px;
              line-height: 20px;
              text-align: center;
            }
          }
          .step3Ico{
             flex: 1;
            height: 30px;
            position: relative;
            .stepRound{
              position: absolute;
              height: 20px;
              width: 20px;
              left: 50%;
              top: 50%;
              z-index: 3;
              background: #999;
              transform: translate(-50%,-50%);
              color: #fff;
              border-radius: 20px;
              font-size: 14px;
              line-height: 20px;
              text-align: center;
            }
          }
          .stepliner{
            position: absolute;
            top: 50%;
            left: 50%;
            right: 0;
            transform: translateY(-50%);
            height: 2px;
            background: #999;
            width: 50%;
          }
          .steplinel{
            position: absolute;
            top: 50%;
            left: 0;
            right: 50%;
            transform: translateY(-50%);
            height: 2px;
            background: #999;
            width: 50%;
          }
          .stepArrow{
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            // font-weight: bold;
            right: -2px;
            font-size: 8px;
            color: #999;
          }
        }
        .stepBottom{
          height: 120px;
          // background: chocolate;
          display: flex;
          justify-content: space-between;
          .stepBitem{
            box-sizing: border-box;
            width: 110px;
            padding-top: 0px;
            // background: red;
            border: 0.1px solid #dddddd;
            height: 100%;
            .stepBitemT{
              color: #444;
              font-size: 14px;
              text-align: center;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .stepRes{
              width: 30px;
              height: 30px;
              background: url(../../assets/images/errorPage/person.png) no-repeat center center;
              background-size: 100% 100%;
              margin: 0 auto 10px;
            }
            .stepWri{
              width: 34px;
              height: 30px;
              background: url(../../assets/images/errorPage/write.png) no-repeat center center;
              background-size: 100% 100%;
              margin: 0 auto 10px;
            }
            .stepGig{
              width: 32px;
              height: 30px;
              background: url(../../assets/images/errorPage/gift.png) no-repeat center center;
              background-size: 100% 100%;
              margin: 0 auto 10px;
            }
            .stepBitemD{
              font-size: 10px;
              line-height: 14px;
              margin-bottom: 5px;
              color: #666;
              text-align: center;
            }
            .stepBitemD:last-child{
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
  
}
.errorCover{
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
  background: rgba(0, 0, 0, .5);
}
}
</style>
